import { get } from "lodash";
import { useSelector } from "react-redux";

import {
  REQUEST_MASTER_EVENTS,
  REQUEST_CREATE_MASTER_EVENTS,
  SET_MASTER_EVENTS,
  SUCCESS_CREATE_MASTER_EVENTS,
  ERROR_GET_MASTER_EVENTS,
  ERROR_CREATE_MASTER_EVENTS,
  SET_MESSAGE_MASTER_EVENTS,
  SUCCESS_DELETE_MASTER_EVENTS,
  SUCCESS_UPDATE_MASTER_EVENTS,
  REQUEST_DELETE_MASTER_EVENTS,
  REQUEST_UPDATE_MASTER_EVENTS,
  ERROR_DELETE_MASTER_EVENTS,
  ERROR_UPDATE_MASTER_EVENTS,
} from "./eventsActionTypes";

interface IState {
  busy: boolean;
  message: string;
  masterEventManagement: any[];
}

const initialState: IState = {
  busy: false,
  message: "",
  masterEventManagement: [],
};

const eventmanagement = (state = initialState, action: Record<string, any>) => {
  switch (action.type) {
    case REQUEST_MASTER_EVENTS:
    case REQUEST_CREATE_MASTER_EVENTS:
    case REQUEST_DELETE_MASTER_EVENTS:
    case REQUEST_UPDATE_MASTER_EVENTS:
      return {
        ...state,
        busy: true,
        message: "",
      };

    case SET_MESSAGE_MASTER_EVENTS:
      return {
        ...state,
        message: "",
      };

    case SET_MASTER_EVENTS:
      return {
        ...state,
        busy: false,
        message: "",
        masterEventManagement: action.payload,
      };

    case SUCCESS_CREATE_MASTER_EVENTS:
      // console.log(action.payload);
      return {
        ...state,
        busy: false,
        message: "",
        masterEventManagement: [...state.masterEventManagement, action.payload],
      };
    case SUCCESS_DELETE_MASTER_EVENTS:
      return {
        ...state,
        busy: false,
        message: "",
        masterEventManagement: state.masterEventManagement.filter(
          (tutorial) => get(tutorial, "_id") !== action.payload
        ),
      };

    case SUCCESS_UPDATE_MASTER_EVENTS:
      return {
        ...state,
        busy: false,
        message: "",
        masterEventManagement: state.masterEventManagement.map((mp) => {
          return get(mp, "_id") === action.payload._id ? action.payload : mp;
        }),
      };

    case ERROR_GET_MASTER_EVENTS:
    case ERROR_CREATE_MASTER_EVENTS:
    case ERROR_UPDATE_MASTER_EVENTS:
    case ERROR_DELETE_MASTER_EVENTS:
      return {
        ...state,
        busy: false,
        message:
          action.payload || "Something happened wrong try again after sometime",
      };
    default:
      return state;
  }
};

export default eventmanagement;

export function useEventManagementMaster() {
  return useSelector((state: Record<string, any>) => state.eventmanagement);
}
